export enum FixedBookingCommentsField {
  Comment = 'comment',
}

export type FixedBookingCommentsFormValues = {
  [FixedBookingCommentsField.Comment]: string;
};
